import { render, staticRenderFns } from "./selectMultiple.vue?vue&type=template&id=89b1de4e&"
import script from "./selectMultiple.vue?vue&type=script&lang=js&"
export * from "./selectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports